import { toString } from 'lodash';

import { storeCreator } from '@/utils/store/store.utils';

import { Recipient, Segment, TaxYearsLimitsIRS } from '../types';

import { combineLimits } from './combineLimits';

interface State {
  limits: TaxYearsLimitsIRS;
  setLimits: (limits: TaxYearsLimitsIRS) => void;
  setSegment: (segment: Segment) => void;
  setRecipients: (recipient: Recipient[]) => void;
  applyLimitsToRecipients: () => void;
  reset: () => void;
  recipients: Recipient[];
  segment: Segment;
}

export const useStore = storeCreator<State>((set, get) => ({
  recipients: [],
  segment: {},
  limits: {},
  
  setRecipients: (recipients: Recipient[]) => set((state) => ({
    ...state,
    recipients,
  })),
  
  setSegment: (segment: Segment) => set((state) => ({
    ...state,
    segment,
  })),

  setLimits: (limits: TaxYearsLimitsIRS) => set((state) => ({
    ...state,
    limits: {
      ...combineLimits(state.limits, limits),
    },
  })),

  applyLimitsToRecipients: () => set((state) => {
    const { limits, recipients } = get();
    
    return {
      ...state,
      recipients: recipients.map((recipient) => ({
        ...recipient,
        contributionAccounts: recipient.contributionAccounts?.map((acc) => {
          if (!acc?.taxYear || !recipient.employeeId || !acc.planId) return acc;

          const contributionAmountMax = toString(limits[acc.taxYear]?.[recipient.employeeId]?.[acc.planId]);

          if (contributionAmountMax) {
            return {
              ...acc,
              contributionAmountMax,
            };
          }

          return acc;
        })
      })),
    };
  }),
  
  reset: () => set((state) => ({ 
    ...state, 
    recipients: [], 
    segment: {}, 
    limits: {} 
  })),
}));